var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.serie
    ? _c(
        "section",
        [
          !_vm.serie.abierta
            ? _c(
                "div",
                { staticClass: "notification is-black my-0 is-radiusless" },
                [
                  _c("i", { staticClass: "fas fa-lock" }),
                  _vm._v("  Serie documental "),
                  _c("b", [_vm._v("Cerrada")]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "box" }, [
            _c("h1", { staticClass: "subtitle is-5" }, [
              _vm._v("Serie documental"),
            ]),
            _vm._v(" "),
            _c("h1", { staticClass: "title is-1" }, [
              _vm._v(_vm._s(_vm.serie.nombre)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("p", [_vm._v(_vm._s(_vm.serie.descripcion))]),
              _vm._v(" "),
              _c("p", { staticClass: "is-size-7" }, [
                _vm._v("Última edición: " + _vm._s(_vm.serie.created_at)),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "buttons" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "button is-primary is-outlined",
                    attrs: {
                      to: {
                        name: "organizacionEditarSerieDocumental",
                        params: { idSerie: _vm.serie.id },
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fas fa-edit" }),
                    _vm._v(" Activar edición de serie\n       "),
                  ]
                ),
                _vm._v(" "),
                _vm.serie.abierta
                  ? _c(
                      "button",
                      {
                        staticClass: "button is-primary is-outlined",
                        on: {
                          click: function ($event) {
                            return _vm.openConfirmCerrar(_vm.serie)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fas fa-lock" }),
                        _vm._v(" Cerrar serie\n       "),
                      ]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "button is-primary is-outlined",
                        on: {
                          click: function ($event) {
                            return _vm.openConfirmAbrir(_vm.serie)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fas fa-unlock" }),
                        _vm._v(" Abrir serie"),
                      ]
                    ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button is-danger is-outlined",
                    on: {
                      click: function ($event) {
                        return _vm.openConfirmDelete(_vm.serie)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fas fa-trash" }),
                    _vm._v(" Eliminar serie\n       "),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box" }, [
            _c("div", { staticClass: "columns" }, [
              _c("div", { staticClass: "column is-8" }, [
                _c("h2", { staticClass: "subtitle is-5" }, [_vm._v("Estados")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tags" },
                  _vm._l(_vm.serie.estados, function (estado, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "tag is-medium",
                        class:
                          index != _vm.serie.estado_inicial
                            ? "is-info"
                            : "is-link",
                      },
                      [_vm._v(_vm._s(estado))]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "column" }, [
                _c("h2", { staticClass: "subtitle is-5" }, [
                  _vm._v("Estado Inicial"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tags" }, [
                  _c("div", { staticClass: "tag is-link is-medium" }, [
                    _vm._v(
                      _vm._s(
                        _vm.serie.estado_inicial &&
                          _vm.serie.estados[_vm.serie.estado_inicial]
                      )
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box" }, [
            _c("h2", { staticClass: "subtitle is-5" }, [_vm._v("Aspectos")]),
            _vm._v(" "),
            _vm.aspectosSerie.length > 0
              ? _c(
                  "div",
                  { staticClass: "tags" },
                  _vm._l(_vm.aspectosSerie, function (a) {
                    return _c(
                      "div",
                      { key: a.id, staticClass: "tag is-light is-medium" },
                      [_vm._v(_vm._s(a.nombre))]
                    )
                  }),
                  0
                )
              : _c("div", [
                  _c("p", { staticClass: "is-italic is-mono" }, [
                    _vm._v(
                      "\n         - No se han asignados aspectos a la serie -\n       "
                    ),
                  ]),
                ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box" }, [
            _c("h2", { staticClass: "subtitle is-5" }, [_vm._v("Estructura")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "columns is-multiline" },
              _vm._l(_vm.serie.estructura, function (subdoc, key) {
                return _c(
                  "div",
                  {
                    key: `doc-${key}`,
                    staticClass: "column is-6 is-4-desktop",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "box p-3 is-flex is-flex-direction-row" },
                      [
                        _c("div", { staticClass: "mr-4" }, [
                          _c("i", {
                            staticClass: "far fa-2x has-text-primary",
                            class: {
                              "fa-copy": subdoc.multiple,
                              "fa-file": !subdoc.multiple,
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "is-flex-grow-1" }, [
                          _c("h4", { staticClass: "title is-6" }, [
                            _vm._v(_vm._s(subdoc.nombre)),
                          ]),
                          _vm._v(" "),
                          _c("h4", { staticClass: "subtitle is-7 mb-3" }, [
                            _vm._v(_vm._s(subdoc.key)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "is-size-7" }, [
                            _c("p", [
                              _c("b", [_vm._v("Formatos")]),
                              _vm._v(": " + _vm._s(subdoc.formatos.join(", "))),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _c("b", [_vm._v("¿Colección?")]),
                              _vm._v(" \n                "),
                              _c("i", {
                                staticClass: "fas",
                                class: {
                                  "fa-check": subdoc.multiple,
                                  "fa-times": !subdoc.multiple,
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(subdoc.multiple ? "Si" : "No") +
                                  "\n               "
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.serie.eventos, function (evento, index) {
            return _c(
              "b-collapse",
              {
                key: index,
                staticClass: "card is-radiusless my-1 is-shadowless",
                attrs: {
                  animation: "slide",
                  open: _vm.openCollapseEvent == index,
                },
                on: {
                  open: function ($event) {
                    _vm.openCollapseEvent = index
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "trigger",
                      fn: function (props) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "card-header is-radiusless",
                              attrs: { role: "button" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "card-header-title is-flex-direction-column is-align-items-start",
                                },
                                [
                                  _c("p", { staticClass: "mb-3" }, [
                                    _vm._v(
                                      "Evento:  " + _vm._s(evento.nombre) + " "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "is-4 ml-5 has-text-primary is-400",
                                      },
                                      [
                                        _c("i", { staticClass: "fas fa-bolt" }),
                                        _vm._v(
                                          " " + _vm._s(evento.acciones.length)
                                        ),
                                      ]
                                    ),
                                    evento.areas_habilitadas
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "is-4 ml-5 has-text-primary is-400",
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-lock",
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  evento.areas_habilitadas
                                                    .length
                                                ) +
                                                " Areas"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "tags is-400" },
                                    [
                                      _vm._l(
                                        evento.estados_iniciales,
                                        function (e) {
                                          return _c(
                                            "span",
                                            {
                                              key: e,
                                              staticClass: "tag",
                                              class:
                                                e != _vm.serie.estado_inicial
                                                  ? "is-light"
                                                  : "is-link",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.serie.estados[e])
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "tag is-white" },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-arrow-right",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.serie.estados[evento.estado_final]
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "tag",
                                              class:
                                                evento.estado_final !=
                                                _vm.serie.estado_inicial
                                                  ? "is-light"
                                                  : "is-link",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.serie.estados[
                                                    evento.estado_final
                                                  ]
                                                )
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            { staticClass: "tag is-light" },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-asterisk",
                                              }),
                                            ]
                                          ),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                { staticClass: "card-header-icon" },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: props.open
                                        ? "angle-up"
                                        : "angle-down",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              },
              [
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("h1", { staticClass: "subtitle is-4" }, [
                    _vm._v("\n           Evento\n         "),
                  ]),
                  _vm._v(" "),
                  _c("h1", { staticClass: "title is-3" }, [
                    _vm._v(
                      "\n           " + _vm._s(evento.nombre) + "\n         "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("div", { staticClass: "columns is-multiline" }, [
                    _c("div", { staticClass: "column is-6" }, [
                      _c("h1", { staticClass: "subtitle is-5" }, [
                        _vm._v("Estados iniciales"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tags" },
                        _vm._l(evento.estados_iniciales, function (e) {
                          return _c(
                            "span",
                            {
                              key: e,
                              staticClass: "tag is-medium",
                              class:
                                e != _vm.serie.estado_inicial
                                  ? "is-light"
                                  : "is-link",
                            },
                            [_vm._v(_vm._s(_vm.serie.estados[e]))]
                          )
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "column is-6" }, [
                      _c("h1", { staticClass: "subtitle is-5" }, [
                        _vm._v("Estados final"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tags" }, [
                        _vm.serie.estados[evento.estado_final]
                          ? _c("span", { staticClass: "tag is-primary" }, [
                              _vm._v(
                                _vm._s(_vm.serie.estados[evento.estado_final])
                              ),
                            ])
                          : _c("span", [
                              _c("i", [
                                _c("i", { staticClass: "fas fa-asterisk" }),
                                _vm._v(
                                  " Mantiene el estado\n                 "
                                ),
                              ]),
                            ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("h1", { staticClass: "subtitle is-5" }, [
                    _vm._v("Areas habilitadas para ejecutar acciones"),
                  ]),
                  _vm._v(" "),
                  evento.areas_habilitadas
                    ? _c(
                        "div",
                        { staticClass: "tags" },
                        _vm._l(evento.areas_habilitadas, function (a) {
                          return _c(
                            "span",
                            { key: a, staticClass: "tag is-dark" },
                            [_vm._v(_vm._s(_vm.getArea(a) || "???"))]
                          )
                        }),
                        0
                      )
                    : _c("div", { staticClass: "content" }, [
                        _c("p", { staticClass: "is-italic is-mono" }, [
                          _vm._v(
                            "Todas las areas pueden ejecutar las acciones"
                          ),
                        ]),
                      ]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("h1", { staticClass: "subtitle is-5" }, [
                    _vm._v("Acciones"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("p", [
                      _vm._v(
                        "El siguiente listado son las acciones del evento."
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  evento.acciones.length === 0
                    ? _c("div", { staticClass: "content" }, [
                        _c("p", { staticClass: "is-italic is-mono" }, [
                          _vm._v(
                            "No se requieren acciones para ejecutar el evento"
                          ),
                        ]),
                      ])
                    : _c(
                        "div",
                        _vm._l(evento.acciones, function (a, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "box is-flex is-flex-direction-row",
                            },
                            [
                              _c("div", { staticClass: "mr-4" }, [
                                _c("i", {
                                  staticClass:
                                    "fas fa-bolt fa-2x has-text-primary",
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "is-flex-grow-1" },
                                [
                                  _c(
                                    "h1",
                                    { staticClass: "subtitle is-6 mb-3" },
                                    [_vm._v("Acción #" + _vm._s(index + 1))]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "my-3 is-italic" }, [
                                    _vm._v(_vm._s(a.descripcion)),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [_c("b", [_vm._v("Parámetros:")])]),
                                  _vm._v(" "),
                                  _vm._l(a.parametros, function (p, index2) {
                                    return _c(
                                      "p",
                                      { key: index2, staticClass: "ml-6" },
                                      [
                                        _c("i", { staticClass: "fas fa-dot" }),
                                        _vm._v(
                                          " " +
                                            _vm._s(index2) +
                                            " \n                   "
                                        ),
                                        _c("i", {
                                          staticClass: "fas fa-arrow-right",
                                        }),
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(p) +
                                            "\n                 "
                                        ),
                                      ]
                                    )
                                  }),
                                ],
                                2
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                ]),
              ]
            )
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }